<template>
    <div class="blackjack-table">
        <div v-if="blackjackTable !== null" class="table-header">
            <div class="header-left">
                <div class="left-title">
                    <router-link to="/blackjack" class="link-back">
                        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 16.18L8 0.820004C8 0.0931494 7.24623 -0.277135 6.79868 0.244006L0.203166 7.92398C-0.0677208 8.23941 -0.0677208 8.76055 0.203166 9.07611L6.79867 16.7561C7.24623 17.2771 8 16.9068 8 16.18Z" />
                            <rect x="6" y="5" width="12" height="7" rx="1" />
                        </svg>
                    </router-link>
                    <div v-if="blackjackTable.game.type === 'standard'" class="title-standard">
                        STANDARD TABLES
                        <div class="title-limits">
                            (
                            <IconCoin />
                            <div class="limits-value">
                                <span>1</span> <span>- 10</span>
                            </div>
                            )
                        </div>
                    </div>
                    <div v-else class="title-whale">
                        WHALE TABLES
                        <div class="title-limits">
                            (
                            <IconCoin />
                            <div class="limits-value">
                                <span>10</span> <span>- 100</span>
                            </div>
                            )
                        </div>
                    </div>
                </div>
                <div class="left-info">LOBBY {{blackjackTable.table + 1}}, GAME ID = {{blackjackTable.game._id}}</div>
            </div>
            <button v-on:click="modalsSetShow('BlackjackRules')" class="button-rules">
                <IconInfo />
                <span class="gradient-yellow" style="color: white;">GAME RULES</span>
            </button>
        </div>

        <BlackjackGame v-if="blackjackTable !== null" v-bind:table="blackjackTable" />
        <Bets />
    </div>
</template>

<script>
        import IconCoin from '@/components/icons/IconCoin';
    import { mapGetters, mapActions } from 'vuex';
    import IconInfo from '@/components/icons/IconInfo';
    import Bets from '@/components/bets/Bets';
    import BlackjackGame from '@/components/blackjack/BlackjackGame';

    export default {
        name: 'Blackjack',
        metaInfo: {
            title: 'Blackjack',
            meta: [{ name: 'description', content: '' }]
        },
        components: {
            IconInfo,
            Bets,
            BlackjackGame,
                IconCoin
        },
        data() {
            return {
                blackjackTable: null
            }
        },
        methods: {
            ...mapActions([
                'modalsSetShow'
            ])
        },
        computed: {
            ...mapGetters([
                'socketBlackjack', 
                'blackjackTables'
            ])
        },
        watch: {
            'blackjackTables': {
                handler(data, oldData) {
                    if(this.blackjackTables.length >= 1) {
                        this.blackjackTable = this.blackjackTables[this.$route.params.tableId - 1];
                    }
                },
                deep: true
            }
        },
        created() {
            if(this.blackjackTables.length >= 1) {
                this.blackjackTable = this.blackjackTables[this.$route.params.tableId - 1];
            }
        }
    }
</script>

<style scoped>
    .blackjack-table {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 45px 10px;
        z-index: 1;
    }

    .blackjack-table .table-header {
        width: 1090px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .blackjack-table .left-title {
        display: flex;
        align-items: center;
    }

    .blackjack-table .title-standard,
    .blackjack-table .title-whale {
        display: flex;
        align-items: center;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 28px;
        font-weight: 900;
        color: #ffffff;
    }

    .blackjack-table .left-title a.link-back {
        margin-right: 20px;
    }

    .blackjack-table .left-title a.link-back svg {
        fill: #c1c1c1;
    }

    .blackjack-table .title-limits {
        display: flex;
        align-items: center;
        margin-left: 15px;
        font-weight: 400;
        font-size: 28px;
        color: #c1c1c1;
    }

    .blackjack-table .limits-value {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 12px;
        font-weight: 600;
        color: #c1c1c1;
    }

    .blackjack-table .title-limits img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }

    .blackjack-table .limits-value span {
        font-size: 16px;
        font-weight: 800;
        color: #ffffff;
    }

    .blackjack-table .left-info {
        margin-top: 10px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 16px;
        font-weight: 600;
        color: #c1c1c1;
        word-break: break-word;
        overflow-wrap: break-word;
    }

    .blackjack-table .table-header button.button-rules {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
    }

    .blackjack-table .table-header button.button-rules svg {
        margin-right: 8px;
        fill: #ffb703;
    }

    @media only screen and (max-width: 1700px) {

        .blackjack-table .table-header {
            width: 100%;
        }

    }

    @media only screen and (max-width: 950px) {

        .blackjack-table {
            padding: 25px 10px 443px 10px;
        }

    }

    @media only screen and (max-width: 850px) {

        .blackjack-table .table-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 15px;
        }

        .blackjack-table .table-header button.button-rules {
            margin-top: 0;
            width: 100%;
            justify-content: center;
        }

        .blackjack-table .header-left {
            width: 100%;
        }

    }

    @media only screen and (max-width: 768px) {

        .blackjack-table {
            padding: 25px 10px 350px 10px;
        }

        .blackjack-table .title-standard,
        .blackjack-table .title-whale {
            font-size: 20px;
        }

        .blackjack-table .title-limits {
            margin-left: 10px;
            font-size: 20px;
        }

        .blackjack-table .limits-value {
            font-size: 10px;
        }

        .blackjack-table .limits-value span {
            font-size: 13px;
        }

        .blackjack-table .title-limits img {
            width: 18px;
            height: 18px;
            margin-right: 6px;
        }

        .blackjack-table .left-info {
            font-size: 13px;
            margin-top: 8px;
        }

        .blackjack-table .table-header button.button-rules {
            font-size: 14px;
            margin-top: 15px;
        }

        .blackjack-table .table-header button.button-rules svg {
            margin-right: 6px;
            width: 16px;
            height: 16px;
        }

        .blackjack-table .left-title a.link-back {
            margin-right: 15px;
        }

        .blackjack-table .left-title a.link-back svg {
            width: 14px;
            height: 14px;
        }

    }

    @media only screen and (max-width: 480px) {

        .blackjack-table {
            padding: 20px 5px 300px 5px;
        }

        .blackjack-table .title-standard,
        .blackjack-table .title-whale {
            font-size: 16px;
            flex-wrap: wrap;
        }

        .blackjack-table .title-limits {
            margin-left: 8px;
            font-size: 14px;
            flex-wrap: wrap;
        }

        .blackjack-table .limits-value {
            font-size: 9px;
        }

        .blackjack-table .limits-value span {
            font-size: 11px;
        }

        .blackjack-table .title-limits img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
        }

        .blackjack-table .left-info {
            font-size: 10px;
            margin-top: 6px;
            word-break: break-word;
            overflow-wrap: break-word;
        }

        .blackjack-table .table-header button.button-rules {
            font-size: 11px;
            margin-top: 12px;
            padding: 8px 12px;
        }

        .blackjack-table .table-header button.button-rules svg {
            margin-right: 5px;
            width: 14px;
            height: 14px;
        }

        .blackjack-table .left-title a.link-back {
            margin-right: 12px;
        }

        .blackjack-table .left-title a.link-back svg {
            width: 12px;
            height: 12px;
        }

        .blackjack-table .header-left {
            width: 100%;
        }

    }
</style>
